import { useEffect, useState } from "react";
import { ref, set, onValue } from "firebase/database";
import type { IProduct } from "../types/types";
import { realtimeDb } from "../utils/firebase";

export function useShoppingList() {
  const [list, setList] = useState<IProduct[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const listRef = ref(realtimeDb, "list");

  const updateList = async (updater: ((prev: IProduct[]) => IProduct[]) | IProduct[]) => {
    let value = list
    if (typeof updater === "function") {
      value = updater(value);
    } else {
      value = updater;
    }
    try {
      setList(value)
      await set(listRef, value);
    } catch (err) {
      console.error("Błąd aktualizacji koszyka:", err);
    }
  }

  useEffect(() => {
    const unsubscribe = onValue(
      listRef,
      snapshot => {
        const data = snapshot.exists() ? snapshot.val() : {};
        setList(Object.values(data));
        setLoading(false);
      },
      err => {
        setError(err.message);
        setLoading(false);
      }
    );

    return () => unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { list, loading, error, setList: updateList };
}
